import React, { Component } from "react";
import PrintIcon from "@mui/icons-material/Print";
import Button from "@mui/material/Button";

class printbtn extends Component {
  print = () => {
    window.print();
  };
  render() {
    return (
      <div className="print-btn">
        <Button onClick={this.print}>
          <span className="print-label">Imprimer</span>
          <PrintIcon />
        </Button>
      </div>
    );
  }
}

export default printbtn;
